module.exports = __webpack_public_path__ + "static/8(4)-0a9fbcc57e143084dc879558695b8c9c.jpg";